import { useCallback } from 'react';

import { Segment } from '../analytics-services/segment';
import { CONNECT_DOWNLOAD_CLICKED } from '../../constants/analytics-events';

export const ConnectEvents = {
  CONNECT_DOWNLOAD_CLICKED,
};

export const ConnectEventSources = {
  CONNECT_SETTINGS_PAGE: 'connect-settings-page',
};

export const useTrackConnectEvent = (eventName: string, source = '') => {
  return useCallback(
    (metadata: Record<string, unknown> = {}) => {
      const payload: Record<string, unknown> = {
        ...metadata,
      };

      if (source) {
        payload.source = source;
      }

      Segment.trackEvent(eventName, payload);
    },
    [eventName, source],
  );
};
